import TunersAndInput from "./TunersAndInput.jsx";

export default TunersAndInput;



// WEBPACK FOOTER //
// ./src/components/pages/Create_portfolio_by_Advisor/common/tunersAndinput/index.js